<template>
  <div>
    <div
      v-for="review in reviews"
      :key="review.id"
      class="my-4 w-full overflow-hidden rounded-md bg-white p-6 shadow-md sm:p-8"
    >
      <ReviewItem :review="review" @reply="reply($event, review)" @delete-response="deleteResponse(review)" />
    </div>
    <div v-if="pagination.lastPage > 1" class="md:col-span-2">
      <BasePagination
        :background-color="false"
        :current-page="pagination.currentPage"
        :last-page="pagination.lastPage"
        :previous-label="$t('ui.table.pagination.previous')"
        :next-label="$t('ui.table.pagination.next')"
        :total="pagination.total"
        @update:change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import { BasePagination } from '@/ui/pagination'
import ReviewItem from './ReviewItem.vue'

export default {
  components: {
    BasePagination,
    ReviewItem
  },
  props: {
    pagination: {
      type: Object,
      required: false,
      default: null
    },
    reviews: {
      type: Array,
      required: true
    }
  },
  emits: ['update:changePage'],
  methods: {
    changePage(page) {
      this.$emit('update:changePage', page)
    },
    reply(responseText, review) {
      review.ownerResponseText = responseText
    },
    deleteResponse(review) {
      review.ownerResponseText = ''
    }
  }
}
</script>
